import { api } from "@/lib/api";
import { uuid } from "@/interfaces";
import type { Availability, AvailabilityDays } from "@shyne/shared/api";

export const IndividualScheduleRepository = {
  mine(shell: uuid): Promise<Availability> {
    return api.availability.get({ actingOrganization: shell });
  },

  saveMine(shell: uuid, days: AvailabilityDays): Promise<Availability> {
    return api.availability.save({ actingOrganization: shell, days });
  },

  ofWorkerContract(contract: uuid): Promise<Availability> {
    return api.workerContracts.availability(contract);
  },
};
